import React, { useState } from 'react';

import useGlobalState from '../GlobalStateContext';
import axios from '../services/MyAxios';
import { PermissionList, RoleList } from 'crm/helpers/Permissions';
import SweetAlert from './alerts/SweetAlert';

type Props = {
    url: string;
    requestData?: object;
    action: () => void;
    roles: RoleList;
    permissions: PermissionList;
    buttonText?: string;
};

export default function InsertButton({
    url,
    requestData,
    action,
    roles,
    permissions,
    buttonText = 'Add',
}: Readonly<Props>) {
    const [loading, setLoading] = useState(false);
    const { loggedAdmin } = useGlobalState();

    function handleInsertClick() {
        if (loading) {
            return;
        }

        setLoading(true);
        axios
            .post(url, requestData)
            .then(() => {
                setLoading(false);
                action();
            })
            .catch(() => {
                SweetAlert.error('Something went wrong...');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function getContent() {
        return loading === true ? (
            <span className="btn btn-primary btn-sm mb-3">
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            </span>
        ) : (
            <button
                type="button"
                className="btn btn-outline-success btn-sm"
                key="insert"
                onClick={() => handleInsertClick()}
            >
                <i className="mdi mdi-plus pr-2" />
                {buttonText}
            </button>
        );
    }

    return loggedAdmin.hasAccess(roles, permissions) ? getContent() : null;
}
